import { useQuery } from "@apollo/client/react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router";
import { buttonClasses } from "@/components/design/button-classes";
import { MatchResultListDocument, SortOrder } from "@/graphql/generated/operations";

export function LatestMatchResultLink({ matchId }: { matchId: string }) {
  const { data } = useQuery(MatchResultListDocument, {
    variables: { input: { first: 1, where: { matchId: { eq: matchId }, kept: { eq: true } }, order: { createdAt: SortOrder.Desc } } },
    fetchPolicy: "cache-and-network",
    pollInterval: 20_000,
  });
  const latest = data?.matchResults.nodes[0];
  return (
    <Link id={`match-latest-result-${matchId}`} to={`/match/${matchId}?step=result${latest ? `&result=${latest.id}` : ""}`}
      className={buttonClasses({ variant: "secondary", size: "compact" })}>
      <FormattedMessage id="match.connections.latestResult" />
      {latest ? ` · ${latest.candidateCount ?? 0}` : null}
    </Link>
  );
}
